"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var userChecks_exports = {};
__export(userChecks_exports, {
  edit: () => edit,
  editFeature: () => editFeature,
  remove: () => remove,
  removeFromProject: () => removeFromProject,
  removeFromTeam: () => removeFromTeam,
  removeFromWorkspace: () => removeFromWorkspace
});
module.exports = __toCommonJS(userChecks_exports);
var import_check = require("../check/index.js");
function edit(user, workspace) {
  return import_check.check.named(`Edit user ${user.screenName} (${user.id})`, import_check.check.workspaceAdmin(workspace));
}
function editFeature(feature) {
  const description = `Edit user feature flag ${feature}`;
  switch (feature) {
    case "ChangeIdentity":
      return import_check.check.named(description, import_check.check.superuser);
    case "IntegrationTest":
    case "NonBillable":
    case "Mobile2Preview":
    case "Mobile2Default":
    case "EnableMobileRiverfly":
    default:
      return import_check.check.named(description, import_check.check.globalAdmin);
  }
}
function remove(user) {
  return import_check.check.named(`Delete user ${user.screenName} (${"id" in user ? user.id : user.userId})`, import_check.check.globalAdmin);
}
function removeFromWorkspace(workspaceId) {
  return import_check.check.named(
    `Remove user from workspace ${workspaceId}`,
    import_check.check.or(import_check.check.globalAdmin, import_check.check.workspaceAdmin(workspaceId))
  );
}
function removeFromProject(project) {
  return import_check.check.named(
    `Remove user from project ${project.id}`,
    // No teamIds array below because team coordinators shouldn't be able to remove a user from a project:
    import_check.check.projectCoordinator(project.id, project.workspaceId, null)
  );
}
function removeFromTeam(team) {
  return import_check.check.named(
    `Remove user from team ${team.id}`,
    // No projectIds array below because project coordinators shouldn't be able to remove a user from a team:
    import_check.check.teamCoordinator(team.id, team.workspaceId, null)
  );
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  edit,
  editFeature,
  remove,
  removeFromProject,
  removeFromTeam,
  removeFromWorkspace
});
//# sourceMappingURL=userChecks.js.map
